import React, { useContext } from "react";

import BreadcrumbControl from "./BreadcrumbControl";
import SalesforceObjectDisplay from "./SalesforceObjectDisplay";
import PluginObjectDisplay from "./PluginObjectDisplay";
import { FormContextProvider } from "../context/formContext";

import { MessagesContext } from "../context/messagesContext";

const WorkspaceDisplay = () => {
  const { pages } = useContext(MessagesContext);

  const renderDisplay = (currentPage) => {
    console.log("RENDER DISPLAY CURRENT PAGE: ", currentPage);
    switch (currentPage.action) {
      case "index":
        return <SalesforceObjectDisplay record={currentPage.record} />;
      case "new":
        return <PluginObjectDisplay />;
      case "edit":
        return <PluginObjectDisplay />;
      default:
        console.log(
          "Error: No display action available for page of type: ",
          currentPage
        );
        break;
    }
  };

  const currentPage = pages[pages.length - 1];

  return (
    <div>
      {pages.length > 0 ? (
        <FormContextProvider>
          <div className="slds-p-top_x-small">
            <BreadcrumbControl pages={pages} />
          </div>
          <div className="slds-p-top_xxx-small">
            {renderDisplay(currentPage)}
          </div>
        </FormContextProvider>
      ) : (
        ""
      )}
    </div>
  );
};

export default WorkspaceDisplay;
